import { call, put, takeLatest } from 'redux-saga/effects';
import HeroFreApi from 'api-services/HeroFreApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { VERIFY_EMAIL } from './actionTypes';
import { doneVerifyingEmail, errorVerifyingEmail } from './actionCreators';
export function* verifyEmail(constAccessParams, action) {
    const result = yield call(HeroFreApi.verifyEmail, constAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(doneVerifyingEmail(result.data));
    }
    else {
        yield put(errorVerifyingEmail(result.msg));
    }
}
export function* watchVerifyEmailCalls(constAccessParams) {
    yield takeLatest(VERIFY_EMAIL, verifyEmail, constAccessParams);
}
//# sourceMappingURL=saga.js.map